"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localization = void 0;
exports.localization = {
    cancel: {
        label: 'annuler les modifications',
        text: 'Annuler',
    },
    close: {
        label: 'fermer',
        text: 'Fermer',
    },
    confirm: {
        label: 'enregistrer les informations',
        text: 'Enregistrer les informations',
    },
    discover: 'Découvrir les différents quartiers',
    districts: 'Quartiers et ateliers',
    groups: 'Quartiers, ateliers & tribus',
    error: 'Cette page a rencontré une erreur.',
    header: {
        title: {
            label: 'revenir à la page des ateliers',
            text: '',
        },
    },
    intro: 'Bienvenue sur le trombinoscope d\'OCTO Technology !',
    login: {
        label: 'se connecter avec son compte OCTO',
        text: 'Se connecter avec son compte OCTO',
    },
    logout: {
        label: 'se déconnecter',
        text: 'Se déconnecter',
    },
    leagues: {
        campement: 'Campement',
    },
    me: {
        label: 'accéder à mon profil',
        text: 'Mon profil',
    },
    members: {
        singular: 'membre',
        plural: 'membres',
    },
    no: 'Non',
    open: {
        label: 'ouvrir',
        text: 'Ouvrir',
    },
    people: 'Octos',
    person: {
        affinities: {
            delete: 'supprimer de ma skill matrix l\'affinité ',
            legend: {
                heart: 'Motivation',
                star: 'Niveau',
            },
            levels: [
                'Je suis une référence',
                'Je peux enseigner',
                'Je suis autonome',
                'Je peux me débrouiller avec de l\'aide',
                'Je n\'y connais rien',
            ],
            motivations: [
                'Très intéressé',
                'J\'aime bien ce sujet',
                'Peu importe',
                'Pas intéressé',
            ],
            update: {
                label: 'mettre à jour ma skill matrix',
                text: 'Mettre à jour ma Skill Matrix',
                subtitle: 'La mise à jour est sauvegardée automatiquement',
            },
            subtitle: 'Niveau / motivation',
            title: {
                'people': 'Personnes ayant cette compétence',
                'skills': 'Compétences enregistrées',
            },
        },
        group: 'Groupe',
        subgroup: 'Tribu',
        description: 'Description',
        staffing_info: 'Infos staffing',
        email: 'E-mail',
        entry: 'Date d\'arrivée',
        form: {
            contact: {
                edit: {
                    label: 'contacter sur mattermost',
                    text: 'Contacter sur Mattermost',
                },
                mail: {
                    label: 'contacter par mail',
                    text: 'Contacter par mail',
                },
                update: {
                    label: 'modifier le numéro de téléphone',
                    text: 'Numéro de téléphone',
                },
            },
            description: {
                title: 'Description',
                edit: {
                    label: 'activer la zone de texte pour modifier mes informations',
                    text: 'Modifier mes informations',
                },
                missing: 'Aucune description renseignée.',
                update: {
                    label: 'modifier la description',
                    text: 'Description',
                },
            },
            certification: {
                add: {
                    label: 'activer la zone de texte pour ajouter une certification',
                    text: 'Ajouter une certification',
                },
                save: {
                    label: 'activer la zone de texte sauvegarder la certification',
                    text: 'Enregistrer',
                },
                certificatName: {
                    label: 'Ecrivez le titre de la certification',
                    text: 'Titre',
                },
                certifier: {
                    label: 'Choisissez un certificateur ou organisme',
                    text: 'Organisme',
                },
                startDate: {
                    label: 'Entrez la date de délivrance',
                    text: 'Date de délivrance',
                },
                expireDate: {
                    label: 'Entrez la date d\'expiration',
                    text: 'Date d\'expiration',
                },
                title: 'Nouvelle certification',
            },
            staffing_info: {
                title: 'Infos staffing',
                edit: {
                    label: 'activer la zone de texte pour modifier mes informations du staffing',
                    text: 'Modifier mes informations staffing',
                },
                missing: 'Aucune information staffing renseignée.',
                update: {
                    label: 'modifier les informations staffing',
                    text: 'informations staffing',
                },
            },
        },
        idf: 'Présent en IDF',
        information: 'Informations',
        level: 'Niveau',
        links: 'Liens utiles',
        managed: 'Managé(e)s',
        manager: 'Manager',
        minibio: 'Minibio',
        missing: 'Non renseigné',
        name: 'Nom & prénom',
        octopod: 'Octopod',
        phone: 'Téléphone',
        photo: {
            label: 'photo de',
        },
        relations: 'Rattachements',
        resume: 'CV',
        roles: {
            main: 'Rôle principal',
            others: 'Rôles',
        },
        skills: 'Skill Matrix',
        timesheet: 'Lien du CRA',
        updated: {
            feminine: 'Mise à jour le',
            masculine: 'Mis à jour le',
        },
    },
    search: {
        groups: 'Quartiers, Ateliers & Tribus',
        people: 'Octos',
        roles: 'Rôles',
        skills: 'Compétences',
        jobs: 'Niveau',
        results: 'Résultats pour la recherche',
        title: {
            label: 'rechercher sur askbob',
            text: 'Effectuer une recherche sur Askbob',
        },
    },
    skill: {
        category: 'Compétence de la catégorie',
        list: {
            label: 'aller à la liste des compétences',
            text: 'Liste des compétences',
        },
        staffing: {
            label: 'aller sur la page staffing d\'Octopod',
            text: 'Staffing d\'Octopod',
        },
    },
    skills: 'Compétences',
    role: {
        people: 'Personnes ayant ce rôle',
    },
    job: {
        people: 'Personnes ayant ce niveau',
    },
    jobs: 'Niveaux',
    outdated: 'Template obsolète',
    roles: 'Rôles',
    group: {
        creation: 'Créée le',
        form: {
            contact: {
                edit: {
                    label: 'contacter par e-mail',
                    text: 'Contacter par e-mail',
                },
                update: {
                    label: 'modifier l\'email',
                    text: 'E-mail',
                },
            },
            description: {
                title: 'Description',
                edit: {
                    label: 'activer la zone de texte pour modifier les informations',
                    text: 'Modifier les informations',
                },
                missing: 'Aucune description renseignée.',
                update: {
                    label: 'modifier la description',
                    text: 'Description',
                },
            },
        },
        leaders: 'Leader(s) & co-leader(s)',
        members: 'Membres',
        secondary_people: 'Contacts Fonctions Coeur',
        title: {
            label: 'accéder à la page groupes',
            text: 'Groupes',
        },
    },
    teams: 'Tribus',
    unknown: 'Cette page n\'existe pas.',
    validate: {
        arialabel: 'valider',
        text: 'Valider',
    },
    workshop: {
        title: {
            label: 'accéder à la fabrique',
            text: 'LA FABRIQUE',
        },
    },
    yes: 'Oui',
};
//# sourceMappingURL=localization.js.map